export default __webpack_public_path__ + "static/media/TRUCK13.f0e1cc24.jpg";